import z from 'zod'

const maxLengthError = (length: number) => {
  return `${length}文字以下で入力してください`
}
export const phoneNumberSchema = z.union([
  // 固定電話
  z.string().regex(/^0[1-9]{3}[0-9]{6}$/, { message: '形式が不正です' }),
  // 携帯電話
  z.string().regex(/^0[1-9]0[0-9]{8}$/, { message: '形式が不正です' })
])
export const urlSchema = z.string().url({ message: 'URLの形式が不正です' })
export const invoiceSchema = z
  .string()
  .regex(/^T[0-9]{13}$/, { message: '形式が不正です' })
export const dispatchLicenseNumberSchema = z
  .string()
  .regex(/派[0-9]{2}-[0-9]{6}/, { message: '形式が不正です' })

export const frequencyCodeSchema = z.enum(['NONE', 'HIGH', 'MIDDLE', 'LOW'])
export const tagCodeSchema = z.enum([
  'NO_DISTRIBUTION',
  'PROJECT_PERSONAL',
  'PROJECT',
  'PROJECT_DEVELOPMENT',
  'PROJECT_FOUNDATION',
  'HUMAN_RESOURCES_BP',
  'HUMAN_RESOURCES_P',
  'NONE'
])
export const postCodeSchema = z
  .string()
  .regex(/^[1-9]{1}[0-9]{6}$/, { message: '形式が不正です' })
export const emailSchema = z.string().email({ message: '形式が不正です' })
export const booleanSchema = z.boolean().nullable()
export const stringSchema = (length: number) =>
  z
    .string()
    .min(1, { message: '必須項目です' })
    .max(length, maxLengthError(length))
export const memoSchema = z.string()
export const numberSchema = z
  .number({ message: '整数値で入力してください' })
  .nonnegative()
export const loginIdSchema = z
  .string()
  .trim()
  .regex(
    new RegExp('^[a-zA-Z0-9]{1,10}@[a-zA-Z0-9]{6}$'),
    '有効なログインIDを入力してください'
  )
export const passwordSchema = z
  .string()
  .trim()
  .min(1, { message: 'パスワードが入力されていません' })
  .max(50, { message: maxLengthError(50) })
export const userCodeSchema = z
  .string()
  .trim()
  .regex(
    new RegExp('^[a-zA-Z0-9]{1,10}$'),
    '有効なユーザーコードを入力してください'
  )
export const authorityCodeSchema = z.enum(['GENERAL', 'ADMIN'])
